const n = "x-m43-measured", e = "x-m43-operation", t = "x-m43-completion";
function r(o) {
  return {
    [n]: "true",
    [e]: o.operation,
    [t]: o.completion
  };
}
function i(o) {
  return {
    m43: {
      measured: !0,
      operation: o.operation,
      completion: o.completion
    }
  };
}
export {
  t as M43_COMPLETION_HEADER,
  n as M43_MEASURED_HEADER,
  e as M43_OPERATION_HEADER,
  r as m43Headers,
  i as m43SpanContext
};
